import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import ContentLayout from './ContentLayout';
import { Box, Typography } from '@mui/material';

interface IContentErrorProps {
  error: string;
}

const ContentError: React.FC<IContentErrorProps> = (props: IContentErrorProps) => {
  const { error } = props;
  return (
    <ContentLayout title='Error'>
      <Box sx={{ width: '100%' }}>
        <Typography className='text-danger'>
          <ErrorIcon />
          {error}
        </Typography>
      </Box>
    </ContentLayout>
  );
};

export default ContentError;
